import { useState } from 'react';

import { useAppNavigate } from '#routes/AppNavLink.tsx';
import { routes } from '#routes/routes.ts';

export const useTableSelection = (props?: { initialSelectedRowIds?: string[]; initialActiveRowId?: string }) => {
    const [selectedRowIds, setSelectedRowIds] = useState<string[]>(props?.initialSelectedRowIds ?? []);
    const [activeRowId, setActiveRowId] = useState<string | null>(props?.initialActiveRowId ?? null);
    const navigate = useAppNavigate();

    const onToggleRow = (rowId: string) => {
        if (selectedRowIds.includes(rowId)) {
            setSelectedRowIds(selectedRowIds.filter(id => id !== rowId));
        } else {
            setSelectedRowIds([...selectedRowIds, rowId]);
        }
        navigate(routes.ORDERS);
    };

    const onSelectMultipleRows = (rowIds: string[] | null) => {
        if (rowIds === null) {
            setSelectedRowIds([]);
        } else {
            setSelectedRowIds(rowIds);
        }
        navigate(routes.ORDERS);
    };

    const onSelectActiveRow = (rowId: string | null) => {
        if (activeRowId === rowId) {
            setActiveRowId(null);
        } else {
            setActiveRowId(rowId);
        }
    };

    return { activeRowId, onSelectActiveRow, selectedRowIds, onToggleRow, onSelectMultipleRows };
};
